<span class="modal-close-icon"><i class="fa-regular fa-circle-xmark" (click)="closeModal('dismiss')"></i></span>
<div class="modal-body">
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <form [formGroup]="couponForm">
        <div class="mt-5">
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="value">Value</label>
              <input type="text" class="form-control" formControlName="value" id="value" placeholder="Value">
            </div>
            <div class="col-md-6 mb-3">
              <label for="type">Coupon type</label>
              <select id="type" class="form-control" formControlName="type">
                <option *ngFor="let type of types" [value]="type">{{ type }}</option>
              </select>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6 mb-3">
              <label for="bookingOption">Booking type (optional)</label>
              <select id="bookingOption" class="form-control" formControlName="bookingOption">
                <option *ngFor="let bookingOption of bookingOptions" [value]="bookingOption">{{ bookingOption }}</option>
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label for="expirationDate">Expiration Date</label>
              <div class="input-group">
                <input type="text" id="expirationDate" name="expirationDate" class="form-control" placeholder="dd.mm.yyyy"
                       ngbDatepicker #ed="ngbDatepicker" firstDayOfWeek="0" [minDate]="minDate"
                       formControlName="expirationDate">
                <button class="btn btn-outline-secondary calendar" (click)="ed.toggle()" type="button" [disabled]="ed.disabled">
                  <i class="fas fa-calendar"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="modal-buttons text-center">
            <button type="button" class="btn btn-default add-edit-button" (click)="closeModal(couponForm)">Save</button>
            <button type="button" class="btn btn-light cancel-button" (click)="closeModal('cancel')">Cancel</button>
          </div>
          <div class="form-row mt-4">
            <div class="alert alert-danger" *ngIf="errorMessage">Error: {{errorMessage}}</div>
          </div>
        </div>
      </form>
    </div>
  </div>
</div>
